<div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" *ngIf="!error">
    <app-contenedor-principal-documentos
        [configuracion]="configuracionDocumentos"
        (adjuntando)="validAdjuntar($event)"
        (numeroElementos)="elementos($event)"
    >
    </app-contenedor-principal-documentos>
</div>

<div *ngIf="error" class="error-component">
    <span>
        No fue posible obtener los datos para mostrar la información, intente más tarde
    </span>
</div>
